import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class EmailParamsResolver implements Resolve<any> {
  constructor(private router: Router) {}

  resolve(route: ActivatedRouteSnapshot): any {
    const actionType = route.queryParamMap.get('actionType');
    const lessonId = route.queryParamMap.get('lessonId');
    const email = route.queryParamMap.get('email');
    const organizationId = route.queryParamMap.get('organizationId');

    if (!actionType || !email) {
      this.router.navigate(['/']);
      return null;
    }

    if (actionType === 'invite' && !lessonId && !organizationId) {
      this.router.navigate(['/']);
      return null;
    }

    if (actionType === 'userinvite' && !organizationId) {
      this.router.navigate(['/']);
      return null;
    }

    return { actionType, lessonId, email, organizationId };
  }
}